import { render, staticRenderFns } from "./ContentAlert.vue?vue&type=template&id=7c22a46e&scoped=true&"
import script from "./ContentAlert.vue?vue&type=script&lang=js&"
export * from "./ContentAlert.vue?vue&type=script&lang=js&"
import style0 from "./ContentAlert.vue?vue&type=style&index=0&id=7c22a46e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22a46e",
  null
  
)

export default component.exports